import { Link } from "react-router-dom";
import { navLinks, contactInfo } from "@/mocks/site";
import { categories as storyCategories } from "@/mocks/stories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-primary-900 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-radar-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑暗爆料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              聚合知情人、线人与内部人私下透露的内容，先核实、再发布，为被指涉方保留回应空间。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-accent-300">
              <i className="ri-mail-line" aria-hidden="true"></i>
              <a
                href={`mailto:${contactInfo.email}`}
                className="transition-colors hover:text-accent-200 cursor-pointer"
              >
                {contactInfo.email}
              </a>
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {navLinks.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/submit"
                  className="text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                >
                  我要爆料
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">内容栏目</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {storyCategories
                .filter((c) => c.id !== "all")
                .slice(0, 6)
                .map((c) => (
                  <li key={c.id}>
                    <Link
                      to={`/stories?category=${c.id}`}
                      className="text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">编辑守则</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                信源优先保护，不留存可识别身份信息
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                单一口述不成稿，多方交叉印证
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                设更正机制，每次修订公开标注
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑暗爆料 · 内容为线人口述整理，涉及个人与机构信息均已脱敏处理。</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line" aria-hidden="true"></i>
            本站不提供任何获取隐私数据的渠道，请读者理性判断。
          </p>
        </div>
      </div>
    </footer>
  );
}